var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShareIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 33,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31.8,
  height: 31,
  rx: 15.5,
  fill: "#F2F0EC"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 31.8,
  height: 31,
  rx: 15.5,
  stroke: "#F2F0EC"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#share-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.2 18.536c-.481 0-.912.19-1.241.488l-4.516-2.628c.032-.146.057-.292.057-.444 0-.152-.025-.297-.057-.443l4.465-2.603a1.897 1.897 0 0 0 3.192-1.387c0-1.051-.849-1.9-1.9-1.9s-1.9.849-1.9 1.9c0 .152.025.298.057.443l-4.465 2.603a1.897 1.897 0 0 0-3.192 1.387 1.897 1.897 0 0 0 3.192 1.387l4.51 2.635c-.032.133-.051.272-.051.412 0 1.02.83 1.849 1.849 1.849 1.02 0 1.85-.83 1.85-1.85s-.83-1.849-1.85-1.849Zm0-7.65c.348 0 .633.285.633.633a.635.635 0 0 1-.633.633.635.635 0 0 1-.633-.633c0-.348.285-.633.633-.633Zm-7.6 5.7a.635.635 0 0 1-.633-.634c0-.348.285-.633.633-.633.348 0 .633.285.633.633a.635.635 0 0 1-.633.634Zm7.6 4.446a.635.635 0 0 1-.633-.634c0-.348.285-.633.633-.633.348 0 .633.285.633.633a.635.635 0 0 1-.633.634Z",
  fill: "#00546F"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "share-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(8.8 8.352)",
  d: "M0 0h15.2v15.2H0z"
})))));
export default SvgShareIcon;